import styled from 'styled-components/macro';

interface Props {
    className?: string;
    headerHeight: number;
    children?: React.ReactNode;
}

export const StickyHeaderContentLayout = (props: Props) => {
    return (
        <S_StickyHeaderContentLayout
            id="scrollmobile"
            className={props.className}
            $paddingTop={props.headerHeight}
        >
            {props.children}
        </S_StickyHeaderContentLayout>
    );
};

const S_StickyHeaderContentLayout = styled.div<{ $paddingTop: number }>`
    padding-top: ${(props) => props.$paddingTop}px;
`;
